import { ValidationErrorData } from './common';
import {
    CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification,
    CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification
} from './graphql-grid';

export type CampaignsNotificationApiValue =
    | CampaignsEditDataQuery_client_campaigns_rowset_GdTextCampaign_notification
    | CampaignsEditDataQuery_client_campaigns_rowset_GdCpmBannerCampaign_notification;

export type NotificationsValue = {
    email: string;
    phone?: string;
    notifications: Array<CampaignNotification>;
    smsInterval: SmsInterval;
};

export type NotificationEditorsState = Record<string, NotificationEditorState>;

export interface NotificationsEditorValidationData {
    common: Record<string, ValidationErrorData[]>;
    notifications: Array<Record<string, ValidationErrorData[]>>;
    isValid: boolean;
}

export interface SmsInterval {
    startTime: number;
    endTime: number;
}

export interface SmsIntervalEditor {
    startTime: number;
    endTime: number;
    inputStartTime: string;
    inputEndTime: string;
}

export interface NotificationEditorData {
    email: string;
    phone?: string;
    isChangedPhone: boolean;
    notifications: Array<CampaignNotification>;
    smsInterval: SmsIntervalEditor;
}

export interface NotificationEditorState extends NotificationEditorData {
    isOpen: boolean;
    errors?: Record<string, ValidationErrorData[]>;
}

export enum NotificationType {
    currentBalance = 'currentBalance',
    endCampaign = 'endCampaign',
    moderationResults = 'moderationResults',
    monitoringResults = 'monitoringResults',
    increaseBalance = 'increaseBalance',
    stopByReachDailyBudget = 'stopByReachDailyBudget', // оба уведомления
    percentOfCurrentBalance = 'percentOfCurrentBalance',
    changeTrafficValue = 'changeTrafficValue',
    campaignEvents = 'campaignEvents',
    xlsReady = 'xlsReady'
}

export enum NotificationSource {
    sms = 'sms',
    email = 'email'
}

export interface CommonNotification {
    source: NotificationSource;
    value: boolean;
    disabled: boolean;
    errors?: Record<string, ValidationErrorData[]>;
}

export interface CurrentBalanceNotification extends CommonNotification {
    type: NotificationType.currentBalance;
}

export interface EndCampaignNotification extends CommonNotification {
    type: NotificationType.endCampaign;
}

export interface ModerationResultsNotification extends CommonNotification {
    type: NotificationType.moderationResults;
}

export interface MonitoringResultsNotification extends CommonNotification {
    type: NotificationType.monitoringResults;
}

export interface IncreaseBalanceNotification extends CommonNotification {
    type: NotificationType.increaseBalance;
}

export interface StopByReachDailyBudgetNotification extends CommonNotification {
    type: NotificationType.stopByReachDailyBudget;
}

export interface CampaignEventsNotification extends CommonNotification {
    type: NotificationType.campaignEvents;
}

export interface XlsReadyNotification extends CommonNotification {
    type: NotificationType.xlsReady;
}

export interface PercentOfCurrentBalanceNotification
    extends CommonNotification {
    type: NotificationType.percentOfCurrentBalance;
    percent?: string;
}

export interface ChangeTrafficValueNotification extends CommonNotification {
    type: NotificationType.changeTrafficValue;
    interval: string;
}

export type CampaignNotification =
    | CurrentBalanceNotification
    | EndCampaignNotification
    | ModerationResultsNotification
    | MonitoringResultsNotification
    | IncreaseBalanceNotification
    | StopByReachDailyBudgetNotification
    | PercentOfCurrentBalanceNotification
    | ChangeTrafficValueNotification
    | CampaignEventsNotification
    | XlsReadyNotification;
